

exports.__esModule = true;
exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
exports.sanitize = sanitize;
exports.Content = Content;
exports.$contentVersion = $contentVersion;
exports.$flushContent = $flushContent;
exports.$renderContent = $renderContent;

var _logger = require('xo-beaver/dist/logger');

var _core = require('../core');

function sanitize(html) {
    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
}

var JSONStringify = JSON.stringify;

JSON.stringify = function (item) {
    if (item instanceof Content) {
        return item.toString();
    }
    return JSONStringify.apply(this, arguments);
};

function Content(key, props) {
    this.key = key;
    this.props = props;
}

Content.cache = {};

Content.get = function (key, props) {

    if (!key) {
        return '';
    }

    props = props || {};

    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
    var cacheVal = Content.cache[cacheKey];

    if (cacheVal !== undefined) {
        return cacheVal;
    }

    cacheVal = Content.cache[cacheKey] = new Content(key, props);

    return cacheVal;
};

Content.prototype.toString = Content.prototype.valueOf = function () {
    if (this.string) {
        return this.string;
    }

    this.string = this.render(false);

    return this.string;
};

Content.prototype.toSafeString = function () {
    if (this.safeString) {
        return this.safeString;
    }

    this.safeString = this.render(true);

    return this.safeString;
};

Content.prototype.render = function (safe) {
    var _this = this;

    if (!this.key) {
        return '';
    }

    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
    var keys = this.key.split('.');

    for (var i = 0; i < keys.length; i++) {
        if (value) {
            value = value[keys[i]];
        } else {
            break;
        }
    }

    if (!value) {
        return '';
    }

    return value.replace(/\{\w+\}/g, function (prop) {
        prop = prop.slice(1, prop.length - 1);

        if (prop === 'country') {
            return $locale.country;
        }

        if (prop === 'lang') {
            return $locale.lang;
        }

        if (_this.props[prop] === undefined) {
            if (!_core.$loader.isLoading()) {
                _logger.$logger.warn('missing_content_prop', {
                    key: _this.key,
                    prop: prop
                }, { unique: true });
            }

            return '';
        }

        var propStr = _this.props[prop].toString();

        if (safe) {
            return sanitize(propStr);
        }

        return propStr;
    });
};

var contentCache = {};
var currentVersion = void 0;

window.addContent = function (country, lang, content, version) {
    var countryCache = contentCache[country] = contentCache[country] || {};

    countryCache[lang] = content;
    currentVersion = version;
};

var metadataCache = {};

window.addMetadata = function (country, lang, metadata) {
    var countryCache = metadataCache[country] = metadataCache[country] || {};

    countryCache[lang] = metadata;
};

function $contentVersion() {
    return currentVersion || '';
}

function $flushContent() {
    contentCache = {};
    metadataCache = {};
}

var PP_SPECIAL_COUNTRIES_ISO_CODES = {
    C2: 'CN'
};

var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/locales/:countryCode/:lang',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                    _logger.$logger.info('cached_content');
                    return contentCache[model.countryCode][model.lang];
                }

                _logger.$logger.info('retrieve_content', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                            _logger.$logger.info('content_retrieved');
                            return contentCache[model.countryCode][model.lang];
                        }

                        throw new Error('content_not_available');
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (content) {
                model.setProperties(content);
                return content;
            });
        }
    }),

    change: function change(country, lang) {

        if (country === this.countryCode && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        this.countryCode = country;
        this.lang = lang;

        return this.reload().then(function () {
            _core.$event.broadcast('contentChange');
        });
    }
});

var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {

    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/metadata/:country/:lang/metadata',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
                    _logger.$logger.info('cached_metadata');
                    return metadataCache[model.country][model.lang];
                }

                _logger.$logger.info('retrieve_metadata', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
                        if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
                            _logger.$logger.info('metadata_retrieved', {
                                uri: uri
                            });
                            return metadataCache[model.country][model.lang];
                        }

                        // Retry if not found in cache
                        _logger.$logger.info('metadata_not_available', {
                            uri: uri
                        });
                        return _core.$promise.reject(new Error('metadata_not_available'));
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (metadata) {
                model.setProperties(metadata);
                return metadata;
            });
        }
    }),

    change: function change(country, lang) {
        var _this2 = this;

        this.country = country;
        this.lang = lang;

        return this.reload().then(function () {
            if (!_this2.noBroadcast) {
                _core.$event.broadcast('metadataChange');
            }
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (_core.$config.supportedCountries) {
            if (!_core.$config.supportedCountries[country]) {
                country = this.country;
            }

            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
                lang = _core.$config.supportedCountries[country][0];
            }
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    normalizeAddressFields: function normalizeAddressFields(content) {

        var CONTENT_MAPPING = {
            line1Label: 'streetAddress',
            line2Label: 'streetAddress2',
            cityLabel: 'city',
            stateLabel: 'state',
            postcodeLabel: 'postalCode'
        };

        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
        for (var prop in CONTENT_MAPPING) {
            if (this.addressEntry && this.addressEntry.strings[prop]) {
                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
            }
        }
    }
});

function mapLanguage(lang) {
    var unselectableLanguages = _core.$config.unselectableLanguages || [];

    if (unselectableLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            return 'en';
        }
    }

    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];

    if (unsupportedLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            var s = lang + '_locale_not_supported';

            throw new Error(s);
        }
    }

    return lang;
}

var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
    api: new _core.$Api({
        uri: '/api/locale'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.content = $ContentModel.instance();
        this.metadata = $MetadataModel.instance();
    },

    retrieve: function retrieve() {
        var self = this;

        return this._super.retrieve.apply(this, arguments).then(function (result) {
            self.lang = mapLanguage(self.lang);
            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {

                // TODO: This at build time... or make sure griffin metadata is complete
                self.metadata.normalizeAddressFields(self.content);

                return result;
            });
        });
    },

    change: function change(country, lang) {

        var self = this;

        lang = mapLanguage(lang);

        if (country === this.country && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        _logger.$logger.info('locale_change', {
            country: country,
            lang: lang
        });

        this.country = country;
        this.lang = lang;

        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {

            // TODO: This at build time... or make sure griffin metadata is complete
            self.metadata.normalizeAddressFields(self.content);

            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
            return loadedData;
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (!_core.$config.supportedCountries[country]) {
            country = this.country;
        }

        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
            lang = _core.$config.supportedCountries[country][0];
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    chooseCountry: function chooseCountry(country) {
        return this.choose(country, null);
    },

    chooseLang: function chooseLang(lang) {
        return this.choose(null, lang);
    },

    getLocaleCode: function getLocaleCode() {
        return this.lang + '_' + this.country;
    },

    getCountryCodeISO: function getCountryCodeISO() {
        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
    }
});

var $locale = exports.$locale = $LocaleModel.instance();

function $renderContent(key, props) {
    return Content.get(key, props);
}

var $localeHelper = exports.$localeHelper = {
    /**
     *
     * @param locale - Ex: en_US
     * @returns {{country: *, dialect}}
     */
    normalizeLocale: function normalizeLocale(locale) {
        if (!locale) {
            return {};
        }

        locale = locale.replace('-', '_');

        var country = void 0;
        var language = void 0;

        if (locale.match(/^\w{2}_\w{2}$/)) {
            locale = locale.split('_');

            language = locale[0];
            country = locale[1];
        } else {
            language = locale;
        }

        return {
            country: country,
            language: language
        };
    }
};

angular.value("sanitize", sanitize);
angular.value("Content", Content);
angular.value("$contentVersion", $contentVersion);
angular.value("$flushContent", $flushContent);
angular.value("$ContentModel", $ContentModel);
angular.value("$MetadataModel", $MetadataModel);
angular.value("$LocaleModel", $LocaleModel);
angular.value("$locale", $locale);
angular.value("$renderContent", $renderContent);
angular.value("$localeHelper", $localeHelper);
_logger.$logger;

_core.$event;

_core.$Model;

_core.$Api;

_core.$meta;

_core.$promise;

_core.$config;

_core.$loader;

_core.$dom;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/locale/locale.js
// module id = ./components/squid/dist/locale/locale.js
// module chunks = 1